import { CircleCheck } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import Checkbox from '@/components/form/Checkbox';
import { Form } from '@/components/ui/form';

const formSchema = z.object({
  isAgreedToWaiver: z.boolean().refine((val) => val === true, {
    message: 'You must agree to the waiver'
  })
});

const WaiverCompletedAlert = ({ onSuccess, activity }) => {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      isAgreedToWaiver: false
    }
  });

  const onSubmit = (values) => {
    if (values.isAgreedToWaiver) {
      onSuccess();
    }
  };

  return (
    <div className="mb-6">
      <Alert variant="success">
        <CircleCheck size={18} />
        <AlertTitle>Completed</AlertTitle>
        <AlertDescription>
          You have previously signed the waiver for {activity.title}.
        </AlertDescription>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="mt-4">
            <Checkbox
              name="isAgreedToWaiver"
              label="I have read and understand the waiver"
            />
            <div className="flex justify-end mt-4">
              <Button size="sm" type="submit">
                Continue
              </Button>
            </div>
          </form>
        </Form>
      </Alert>
    </div>
  );
};

export default WaiverCompletedAlert;
